import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-filter-panel',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.css'],
})
export class FilterPanelComponent {

  /** Whether the panel is open */
  @Input() open: boolean = false;

  /** Custom width for the panel (e.g. '400px', '40vw'). Default uses CSS value. */
  @Input() panelWidth: string = '';

  /** Label for the search button (default: 'Search') */
  @Input() searchLabel: string = 'Search';

  /** Whether to show the Clear All button */
  @Input() showClearAll: boolean = true;

  /** Whether to show the Close button */
  @Input() showClose: boolean = true;

  /** Emitted when the Close button or overlay is clicked */
  @Output() close = new EventEmitter<void>();

  /** Emitted when the Clear All button is clicked */
  @Output() clearAll = new EventEmitter<void>();

  /** Emitted when the Search button is clicked */
  @Output() search = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }

  onClearAll(): void {
    this.clearAll.emit();
  }

  onSearch(): void {
    this.search.emit();
  }

  onOverlayClick(): void {
    this.close.emit();
  }
}
